var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_10x10_flag_photo",
    "data-name": "10x10 flag photo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4644",
    "data-name": "Rectangle 4644",
    width: 10,
    height: 10,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_272",
    "data-name": "Mask Group 272",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email-4",
    transform: "translate(0 1.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9983",
    "data-name": "Group 9983",
    transform: "translate(0 2.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9982",
    "data-name": "Group 9982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21269",
    "data-name": "Path 21269",
    d: "M5.289,6.263a.568.568,0,0,1-.59,0L0,3.394V7.208A1.476,1.476,0,0,0,1.476,8.684H8.524A1.476,1.476,0,0,0,10,7.208V3.394Z",
    transform: "translate(0 -3.394)",
    fill: "#8e8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9985",
    "data-name": "Group 9985",
    transform: "translate(0.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9984",
    "data-name": "Group 9984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21270",
    "data-name": "Path 21270",
    d: "M8.524,1.316H1.476A1.467,1.467,0,0,0,.047,2.473L5.006,5.5,9.953,2.473A1.467,1.467,0,0,0,8.524,1.316Z",
    transform: "translate(-0.047 -1.316)",
    fill: "#8e8e8e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0549448c660739adb429e1bf9104f051.svg";
export { ForwardRef as ReactComponent };